import {Box, IconButton} from '@mui/material';
import {t} from 'i18next';

import UploadButton from './UploadButton';

import {ReactComponent as CheckMarkIcon} from '../../../../../../assets/images/checkmark.svg';

import './UploadProtocol.scss';

const UploadProtocol = () => {
  const protocolItems = [
    {
      label: t('ai.review.protocolIntelligence.caseContext'),
      completed: true,
    },
    {
      label: t('ai.review.protocolIntelligence.relevanceCriteria'),
      completed: true,
    },
    {
      label: t('ai.review.protocolIntelligence.issueCodes'),
      completed: true,
    },
  ];

  return (
    <Box className="manage-protocol-content-body">
      <Box
        className="manage-protocol-content-body-text"
        aria-label={t('ai.review.protocolIntelligence.noProtocol')}
      >
        <Box className="manage-protocol-content-body-text-header" tabIndex={0}>
          {t('ai.review.protocolIntelligence.noProtocol')}
        </Box>

        <Box
          className="manage-protocol-content-body-text-subHeader"
          tabIndex={0}
        >
          {t('ai.review.protocolIntelligence.uploadPrompt')}
        </Box>
      </Box>

      <Box
        className="manage-protocol-content-body-text-items"
        aria-label="protocol-items"
      >
        {protocolItems.map((item, index) => (
          <Box
            key={index}
            className="manage-protocol-content-body-text-item"
            aria-label={item.label}
          >
            <Box
              className="manage-protocol-content-body-text-label"
              tabIndex={0}
            >
              {item.label}
            </Box>

            <Box aria-label="protocol-item-status" tabIndex={0}>
              {item.completed && (
                <IconButton disabled aria-label={`${item.label}-completed`}>
                  <CheckMarkIcon />
                </IconButton>
              )}
            </Box>
          </Box>
        ))}
      </Box>

      <Box
        className="upload-protocol"
        aria-label={t('ai.review.protocolIntelligence.uploadProtocol')}
      >
        <UploadButton
          className="upload-protocol-button"
          size="medium"
          ariaLabel={t('ai.review.protocolIntelligence.uploadProtocol')}
          tabIndex={0}
          dataTestId="upload-protocol-upload-protocol-button"
        >
          {t('ai.review.protocolIntelligence.uploadProtocol')}
        </UploadButton>

        <Box className="upload-file-types" mt={2} tabIndex={0}>
          {t('ai.review.protocolIntelligence.uploadFileTypes')}
        </Box>
      </Box>
    </Box>
  );
};

export default UploadProtocol;
